import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  quote: string;
  location?: string;
}
export function TestimonialCard({
  name,
  age,
  quote,
  location = 'Argentina'
}: TestimonialCardProps) {
  return <div className="bg-white p-6 md:p-8 rounded-lg shadow-lg border-2 border-gray-100 hover:border-blue-400 transition-colors duration-200" data-id="element-20">
      <div className="flex items-center gap-1 mb-4" role="img" aria-label="5 estrellas" data-id="element-21">
        {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-blue-500 text-blue-500" aria-hidden="true" data-id="element-22" />)}
      </div>

      <p className="text-gray-700 text-base md:text-lg mb-4 italic leading-relaxed" data-id="element-23">
        "{quote}"
      </p>

      <div className="flex items-center gap-3" data-id="element-24">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-white font-bold text-lg" data-id="element-25">
          {name.charAt(0)}
        </div>
        <div data-id="element-26">
          <p className="font-bold text-gray-900" data-id="element-27">
            {name}, {age} años
          </p>
          <p className="text-sm text-gray-600" data-id="element-28">{location}</p>
        </div>
      </div>
    </div>;
}